import React, { useState } from "react";
import VoidInvoice from "./VoidInvoice";
import "../../../Style/actionstyle.scss";
import PrintInvoice from "./PrintInvoice";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { IconButton, Stack, Box, Tooltip, Button } from "@mui/material";

export default function GeneralIncomeAction({ editData, setRefetch, detailsData }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openPrint, setOpenPrint] = useState(false);
  const handleOpenPrint = () => setOpenPrint(true);
  const handleClosePrint = () => setOpenPrint(false);

  return (
    <div>
      <Stack direction="row" justifyContent="right" spacing={1}>
        <Stack direction="column" justifyContent="center">
          <Tooltip title="void invoice" placement="top">
            {editData?.isVoided ? (
              <Button className="btn-void-disabled">
                Void
              </Button>
            ) : (
              <Button onClick={handleOpenEdit} className="btn-void">
                Void
              </Button>
            )}
          </Tooltip>
        </Stack>
        <Tooltip title="print invoice" placement="top">
          <IconButton onClick={handleOpenPrint}>
            <Box className="save-container">
              <LocalPrintshopIcon className="save-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <PrintInvoice
        open={openPrint}
        editData={editData}
        detailsData={detailsData}
        handleClose={handleClosePrint}
      />
      <VoidInvoice
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />
    </div>
  );
}
